module.exports = __webpack_public_path__ + "static/Insight-home-Hero-f9fb7a42064faf7b4b1eda467d4807b5.jpg";